import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deviceActionSelector, selectedDeviceSelector } from "../../../store/api/devices/selectors";
import { useRunOnDemandTaskMutation } from "../../../store/api/tasks/taskApiSlice";
import { useStoreDispatch } from "../../../store/hooks";
import { taskActionPayload } from "../../Actions/ActionHelper";
import { setBasicDialogOpenFor, setConfirmDialog, setIsLoadingStatus, setOpenToast } from "../../../store/helpers/helperReducers";

import { setDeviceAction, setSelectedType } from "../../../store/api/devices/reducers";
import { useGetZoneListMutation } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { IOption } from "../../Shared/Filter/types";
import { IFullDeviceDetails, IZoneDevice } from "../../../store/api/deviceConfig/types";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { errorMessage } from "../../../utils/helpers";

export const useRemScanData = () => {
  const dispatch = useStoreDispatch();
  const [referenceSinglePowerEnabled, setReferenceSinglePowerEnabled] = useState("false");
  const [zones, setZones] = useState<IOption[]>([]);
  const [zoneOption, setZoneOption] = useState<IOption[]>([]);

  const deviceAction = useSelector(deviceActionSelector);
  const selectedDevice: IFullDeviceDetails = useSelector(selectedDeviceSelector);

  const [runOnDemandTask, runOnDemandTaskStatus] = useRunOnDemandTaskMutation();
  const [getZoneList, zoneStatus] = useGetZoneListMutation();

  useEffect(() => {
    dispatch(setIsLoadingStatus({ remScan: runOnDemandTaskStatus.isLoading || zoneStatus.isLoading }));
  }, [dispatch, runOnDemandTaskStatus.isLoading, zoneStatus.isLoading]);

  const submitOKHandler = async () => {
    let remScanResponse: any;
    try {
      const zoneIds = (zones.length > 0 && zones?.map((item: IOption) => item.value)) || [];
      const newRemStartData = {
        zones: zoneIds?.length > 0 ? zoneIds.toString() : "",
        referenceSinglePowerEnabled,
        taskName: deviceAction.taskName,
        deviceKey: deviceAction.deviceKey,
      };
      const payload = taskActionPayload[deviceAction.taskName](newRemStartData);
      if (payload) {
        remScanResponse = await runOnDemandTask(payload);
      }
      if (remScanResponse?.error) throw remScanResponse.error;
      if (remScanResponse?.data) {
        dispatch(setBasicDialogOpenFor(undefined));
        dispatch(setOpenToast({ openToast: true, toastType: "success", message: remScanResponse?.data }));
        dispatch(setDeviceAction({ taskName: "" }));
        dispatch(setIsLoadingStatus({ remScan: false }));
      }
    } catch (error: any) {
      
      dispatch(setBasicDialogOpenFor(undefined));
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
      dispatch(setDeviceAction({ taskName: "" }));
      dispatch(setIsLoadingStatus({ remScan: false }));
    }
  };

  const handleClickOnStop = async (actionName: string) => {
    if (!actionName) return;
    try {
      if (actionName.match("stop")) {
        let remScanResponse: any;
        const payload = taskActionPayload[deviceAction.taskName]({ taskName: deviceAction.taskName, deviceKey: deviceAction.deviceKey });

        remScanResponse = await runOnDemandTask(payload);
        if (remScanResponse?.error) throw remScanResponse.error;
        if (remScanResponse?.data) {
          dispatch(setConfirmDialog(null));
          dispatch(setOpenToast({ openToast: true, toastType: "success", message: remScanResponse?.data }));
          dispatch(setDeviceAction({ taskName: "" }));
        }
      }
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: errorMessage(error) }));
      dispatch(setDeviceAction({ taskName: "" }));
    }
  };

  const remScanClickHandler = async () => {
    const args = {
      filters: `page=0&size=50`,
      deviceKey: selectedDevice?.objectKey,
      deviceNode: selectedDevice?.nodeType,
    };
    try {
      let zoneResult: any;

      zoneResult = await getZoneList(args);
      if (zoneResult?.error) throw zoneResult.error;
      if (zoneResult?.data.status === 200) {
        let zoneIndexList: IOption[] = [];
        const zoneData = zoneResult.data.data || [];
        if (zoneData.length > 0) {
          zoneData.forEach((element: IZoneDevice) => {
            zoneIndexList.push({ title: element?.index || "", value: element?.index || "" });
          });
        }
        setZoneOption(zoneIndexList);
      }
    } catch (error: any) {
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: error?.data ? JSON.stringify(error?.data) : errorMessage(error) }));
    }
    if (selectedDevice?.remScanActive) {
      dispatch(setDeviceAction({ taskName: "LTEREMStop", deviceKey: selectedDevice.objectKey }));
      dispatch(setConfirmDialog(DIALOGOPENFOR.REMSCANSTOP));
    } else {
      dispatch(setDeviceAction({ taskName: "LTEREMStart", deviceKey: selectedDevice.objectKey }));
      dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.REMSCANSTART));
    }
    dispatch(setSelectedType("remScan"));
  };

  return {
    zones,
    setZones,
    referenceSinglePowerEnabled,
    setReferenceSinglePowerEnabled,
    submitOKHandler,
    runOnDemandTaskStatus,
    handleClickOnStop,
    getZoneList,
    zoneStatus,
    zoneOption,
    setZoneOption,
    remScanClickHandler,
  };
};
